import React from "react";
import { Redirect, Route, Switch, asyncComponent } from "../../../components";
const Customers = ({ match }) => (
  <div className="app-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
      <Route
        path={`${match.url}/list`}
        component={asyncComponent(() => import("./routes/list"))}
      />
      <Route
        path={`${match.url}/add/:cloneId?`}
        component={asyncComponent(() => import("./routes/add"))}
      />
      <Route
        path={`${match.url}/approved`}
        component={asyncComponent(() => import("./routes/approved"))}
      />
      <Route
        path={`${match.url}/new`}
        component={asyncComponent(() => import("./routes/new"))}
      />
      <Route
        path={`${match.url}/orders/:editId`}
        component={asyncComponent(() => import("./routes/orders"))}
      />
      <Route
        path={`${match.url}/upload`}
        component={asyncComponent(() => import("./routes/customers-upload"))}
      />
      <Route
        path={`${match.url}/notes/add/:editId`}
        component={asyncComponent(() => import("./routes/addNotes"))}
      />
      <Route
        path={`${match.url}/notes/edit/:noteId`}
        component={asyncComponent(() => import("./routes/addNotes"))}
      />
      <Route
        path={`${match.url}/notes/:editId`}
        component={asyncComponent(() => import("./routes/notes"))}
      />
      <Route
        path={`${match.url}/view/:editId`}
        component={asyncComponent(() => import("./routes/view"))}
      />
      <Route
        path={`${match.url}/edit/:editId`}
        component={asyncComponent(() => import("./routes/add"))}
      />
      <Route
        path={`${match.url}/payments/:editId`}
        component={asyncComponent(() => import("./routes/payments"))}
      />
      <Route
        path={`${match.url}/menu/:editId`}
        component={asyncComponent(() => import("./routes/menu"))}
      />
      <Route
        path={`${match.url}/item/:editId`}
        component={asyncComponent(() => import("./routes/item"))}
      />
      <Route
        component={asyncComponent(() =>
          import("app/routes/extraPages/routes/404")
        )}
      />
    </Switch>
  </div>
);

export default Customers;
